/**
 * Casas decimais para exibir uma quantidade: 0 para inteiros ("826"), só as
 * necessárias para fração ("1,6", "41,28308"), no máximo 6. Evita tanto o
 * "6" enganoso para 6,4 quanto o "826,000000".
 */
export function escalaQuantidade(quantidade?: number): number {
  if (quantidade === undefined || quantidade === null) return 0;
  const texto = Math.abs(Math.round(quantidade * 1e6) / 1e6).toString();
  const decimais = texto.includes(".") ? texto.split(".")[1].length : 0;
  return Math.min(6, decimais);
}
